import BreakfastCerealProduct from 'models/BreakfastCerealProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BreakfastCerealNutrition from './BreakfastCerealNutrition'
import BreakfastCerealPackage from './BreakfastCerealPackage'

const productOptions = {
  nutritionInfo: <BreakfastCerealNutrition />,
  packagingInfo: <BreakfastCerealPackage />,
  productTitle: 'Brand Specific Whole Grain Breakfast Cereal',
  model: BreakfastCerealProduct,
  validCategories: ['05'],
  validSubCategories: ['001BC'],
  brandSpecific: true,
}

const BSBreakfastCereal = () => <ProductForm product={productOptions} />

export default BSBreakfastCereal
